<app-header></app-header>
<div *ngIf="post == null" class="container px-md-0 text-center mt-4 pt-5">

    <img src="../../../assets/img/loader.gif" class="loader">

</div>
<div *ngIf="post!=null" class="container mb-3">
    <div class="row align-items-center">
        <div class="col-md-6 feature-txt">
            <a (click)="onBackPress()" class="back-btn d-flex align-items-center ml-0 text-orange"><span
                    class="material-icons-outlined">navigate_before</span>
                <span class="">{{post.type.name}}</span></a>
            <h2 class="h2 heading-border">{{post.name}}</h2>
            <p class="m-0 mt-1">on <span *ngIf="post.updatedOn">{{post.updatedOn | date}}</span><span
                    *ngIf="!post.updatedOn">{{post.created_on}}</span></p>
        </div>

        <div class="col-md-6 pt-100">
            <img [src]="post.image" class="img-fluid">
            <div class="pt-2">Share Post<br>
                <a (click)="onSocialShare('in')" class="mr-2"><i class="fa fa-linkedin post-icon"></i></a>
                <a (click)="onSocialShare('tw')" class="mr-2"><i class="fa fa-twitter post-icon"></i></a>
                <a (click)="onSocialShare('fb')" class="mr-2"><i class="fa fa-facebook post-icon"></i></a>
                <!-- <a href=""><i class="fa fa-envelope post-icon"></i></a> -->
            </div>
        </div>

    </div>
</div>

<div *ngIf="post!=null && post.type != undefined && !post.type.formRequired" class="container px-md-0 pt-4">
    <div class="row">
        <div class="col-md-8">
            <div class="py-3">
                <quill-view-html [content]="html" theme="snow"></quill-view-html>
            </div>

            <hr>
            <nav>
                <ul class="pager">
                    <li class="pager-prev"><a [ngClass]="{deactive: !previousPostSlug}" (click)="onPrevNextPostClick(previousPostSlug)" rel="prev">← PREVIOUS POST</a></li>
                    <li class="pager-next"><a [ngClass]="{deactive: !nextPostSlug}" (click)="onPrevNextPostClick(nextPostSlug)" rel="next">NEXT POST →</a></li>
                </ul>
            </nav>


        </div>

        <div class="col-md-4 pt-4 pb-4 lt-border">
            
            <div class="mt-4">

                <section class="widget widget_categories">
                    <h4 class="h4">Tags</h4>
                    <ul class="categories">
                        <li class="pb-2" *ngFor="let tag of post.tags"><a (click)="onTagPress(tag)">{{tag.name}}</a></li>
                    </ul>
                </section>


            </div>

            <hr>

            <div class="mt-4 align-items-center">
                <h4 class="h4">Follow us</h4>
                <a style="color:grey;text-decoration:none;" href="https://in.linkedin.com/company/airo-digital-labs"
                    target="_blank"><i class="fab fa-linkedin"></i></a>
            </div>

        </div>

    </div>
    <!-- <div class="row py-4">
    	<div class="col">        	
            <a (click)="onSocialShare('fb')" class="orange-text active">Facebook</a>
            <br>
            <a (click)="onSocialShare('in')" class="orange-text active">LinkedIn</a>
            <br>
            <a (click)="onSocialShare('tw')" class="orange-text active">Twitter</a>
        </div>
    </div> -->

</div>

<div *ngIf="post!=null && post.type != undefined && post.type.formRequired == true" class="bg-grey pt-0">
    <div class="container py-5">
        <div class="row">
            <div class="col-md-7 text-justify pr-md-5">

                <div class="py-3">
                    <quill-view-html [content]="html" theme="snow"></quill-view-html>
                </div>
                <hr>
                <div class="row py-4">
                    <div class="col">
                        <span>Tags: </span>
                        <a *ngFor="let tag of post.tags; let i = index" (click)="onTagPress(tag)"
                            class="orange-text active">{{tag.name}}{{(i==post.tags.length-1)?'':'/ '}}</a>
                    </div>
                </div>
        
                <hr>
                    <nav>
                        <ul class="pager">
                            <li class="pager-prev"><a (click)="onPrevNextPostClick(previousPostSlug)" rel="prev">← PREVIOUS POST</a></li>
                            <li class="pager-next"><a (click)="onPrevNextPostClick(nextPostSlug)" rel="next">NEXT POST →</a></li>
                        </ul>
                    </nav>
            </div>



            <div class="col-md-5 form-bg bg-white p-5 mt-2 mb-5">
                <p class="h4 text-center pb-3">DOWNLOAD THE WHITEPAPER</p>
                <form [formGroup]="whitepaperForm">
                    <div class="row">
                        <div class="col-md-12 mb-4">
                            <input formControlName="name" class="search form-control pl-3" type="text"
                                placeholder="Name*">
                            <span class="alert small mt-2"
                                *ngIf="(whitepaperFormControl.name.touched || submit) && whitepaperFormControl.name.errors?.required">
                                Please enter your name</span>
                            <span class="alert small mt-2"
                                *ngIf="whitepaperFormControl.name.touched && whitepaperFormControl.name.errors?.pattern">
                                Please enter a valid name</span>
                        </div>
                        <div class="col-md-12 mb-4">
                            <input formControlName="email" class="search form-control pl-3" type="text"
                                placeholder="Email*">
                            <span class="alert small mt-2"
                                *ngIf="(whitepaperFormControl.email.touched || submit) && whitepaperFormControl.email.errors?.required">
                                Please enter your mail id</span>
                            <span class="alert small mt-2"
                                *ngIf="whitepaperFormControl.email.touched && whitepaperFormControl.email.errors?.email">
                                Please enter a valid email address</span>
                        </div>
                        <!-- <div class="col-md-12 mb-4">
                            <input formControlName="contact" class="search form-control pl-3" type="text"
                                placeholder="Contact Number">
                            <span class="alert small mt-2"
                                *ngIf="(whitepaperFormControl.contact.touched || submit) && whitepaperFormControl.contact.errors?.pattern">
                                Please enter a valid contact number</span>
                        </div> -->
                        <div class="col-md-12 mb-4">
                            <input formControlName="company" class="search form-control pl-3" type="text"
                                placeholder="Company Name">
                        </div>
                        <div class="col-md-12 mb-4">
                            <input formControlName="jobTitle" class="search form-control pl-3" type="text"
                                placeholder="Job Title">
                        </div>
                        <!-- <div class="col-md-12 mb-4">
                            <textarea formControlName="message" class="form-control search" rows="2"
                                placeholder="Enter Message"></textarea>
                        </div> -->
                    </div>
                    <p class="small mt-2">By sharing your details, you agree with OMNI's <a
                            href="https://app.omnicoe.com/tnc" class="active">terms of use</a> and <a
                            href="https://app.omnicoe.com/tnc" class="active">privacy policy</a>.</p>
                    <div class="pt-4">
                        <a (click)="submitWhitePaper()"
                            class="bg-button btn btn-primary bd-highlight text-white">Submit</a>

                    </div>
                </form>
            </div>

        </div>

        

        
    </div>
</div>


<div *ngIf="post!=null && related.length>0"
    [ngClass]="post.type.formRequired?'w-100 bg-light':'bg-grey pt-0'">


    <div class="container py-5 px-md-0">

        <div class="row">
            <div class="col pb-5 text-center">
                <h2 class="h2">You May also like</h2>
            </div>
        </div>


        <div class="row">
            <div *ngFor="let post of related" (click)="onPostClick(post)" class="col-md-4">
                <a class="card blog-card">
                    <div class="img-fluid img-resizer" [ngClass]="post.image ? 'background-icon' : ''"
                        [style.background-image]="post.image ? 'url('+post.image+')' : ''"></div>
                    <div class="card-body">
                        <p class="pb-0 m-0 font-small text-uppercase">{{post.type.name}}</p>
                        <p class="h4 m-0 clip-text">{{post.name}}</p>
                        <p class="pb-0 m-0 mt-1  font-small"> {{post.created_on | date: 'MMM dd, yyyy'}}</p>

                    </div>
                </a>
            </div>


        </div>
    </div>
</div>


<app-footer></app-footer>

<div class="modal fade" id="thanks-modal" tabindex="-1" role="dialog" aria-labelledby="thanks-modal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body text-center">
                <h5 class="modal-title">Thanks for the request!</h5>
                <p>We have Emailed the Whitepaper on your email id.</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary border-button" data-dismiss="modal">Ok</button>
            </div>
        </div>
    </div>
</div>